var PROPS_TO_FILTER = ['blurHandler', 'changeHandler', 'className', 'focusHandler', 'label', 'containerStyleOverrides', 'inputStyleOverrides', 'labelStyleOverrides'];
export { PROPS_TO_FILTER };